import React from 'react';
import { ControlLink, Stack, Text } from '@moda/om';
import { hrefFor } from '../../routers';
import { OrderItem, OrderItemStatusGroup } from '../../hooks/useOrder';

interface Props {
  orderItems: OrderItem[];
  orderNumber: string;
}

export const AccountOrderActionTrack: React.FC<Props> = ({ orderItems, orderNumber }) => {
  if (!orderItems) {
    return null;
  }

  return (
    <Stack alignItems="flex-start" space={1}>
      {orderItems && orderItems[0].attributes.shipmentTrackingUrl && (
        <ControlLink href={orderItems[0].attributes.shipmentTrackingUrl}>
          <Text treatment="body2" color="ink">
            Track Shipment
          </Text>
        </ControlLink>
      )}
      {orderNumber &&
        orderItems &&
        orderItems[0].attributes?.statusGroup === OrderItemStatusGroup.Shipped &&
        orderItems[0].attributes.isReturnable && (
          <ControlLink
            to={hrefFor.RequestReturnPage({
              orderNumber
            })}
          >
            <Text treatment="body2" color="ink">
              Request Return
            </Text>
          </ControlLink>
        )}
    </Stack>
  );
};
